import type { InventoryReceived } from './types'

const STORAGE_KEY = 'erp.inventory.received.v1'

function safeParse(json: string | null): InventoryReceived[] {
  if (!json) return []
  try {
    const parsed = JSON.parse(json)
    if (!Array.isArray(parsed)) return []
    return parsed as InventoryReceived[]
  } catch {
    return []
  }
}

function seedIfEmpty(): void {
  if (window.localStorage.getItem(STORAGE_KEY)) return
  const today = new Date().toISOString().slice(0, 10)
  const seed: InventoryReceived[] = [
    {
      id: 'seed-1',
      code: 'REC-1775215906647',
      receivedDate: today,
      sourceWarehouseId: '2',
      destinationWarehouseId: '3',
      destinationBranchId: '3',
      sourceWarehouseName: '2 — test warehouse2',
      destinationWarehouseName: '3 — test warehouse3',
      remarks: '',
      status: 'received',
      lines: [],
    },
    {
      id: 'seed-2',
      code: 'REC-1775215906648',
      receivedDate: today,
      sourceWarehouseId: '1',
      destinationWarehouseId: '4',
      destinationBranchId: '1',
      sourceWarehouseName: 'WH1 — Central warehouse',
      destinationWarehouseName: 'WH4 — Receiving dock',
      remarks: 'Sample row (mock)',
      status: 'pending',
      lines: [],
    },
  ]
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(seed))
}

export function listReceipts(): InventoryReceived[] {
  seedIfEmpty()
  return safeParse(window.localStorage.getItem(STORAGE_KEY))
}

export function getReceipt(id: string): InventoryReceived | undefined {
  return listReceipts().find((r) => r.id === id)
}

export function upsertReceipt(receipt: InventoryReceived): void {
  const all = listReceipts()
  const idx = all.findIndex((r) => r.id === receipt.id)
  const next = idx >= 0 ? all.map((r, i) => (i === idx ? receipt : r)) : [receipt, ...all]
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
}
